
import SessionListElement from "@/model/SessionListElement";
import api from "@/service/api";
import Vue from "vue";
import Component from 'vue-class-component';
import { Prop } from "vue-property-decorator";
import SingleSummary from "./SingleSummary.vue";

@Component({
    components: {
        SingleSummary,
    },
})
export default class SessionSummaryWindow extends Vue {
    @Prop({
        type: Object,
        required: true,
    })
    session!: SessionListElement;

    clients: Array<{
        linkCode: string;
        fullName: string;
        email: string;
        claimedAt: number;
        photographerComment: string;
    }> = [];

    isLoading: boolean = true;

    async mounted() {
        try {
            this.clients = await api.getSingleSessionClients(this.session.id);
        } catch (error) {
            console.error('Error loading clients:', error);
        } finally {
            this.isLoading = false;
        }
    }
}
